import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "ui/components/sheet";

export default function EvtSheet({
  open,
  setOpen,
  disabled = false,
  title,
  description,
  trigger,
  footer,
  className = "",
  children,
}) {
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild disabled={disabled}>
        {trigger}
      </SheetTrigger>
      <SheetContent className={className}>
        <SheetHeader>
          <SheetTitle>{title}</SheetTitle>
          {description && <SheetDescription>{description}</SheetDescription>}
        </SheetHeader>
        <div className="p-4 h-full flex flex-col overflow-auto">{children}</div>
        {footer && <SheetFooter className="flex-1">{footer}</SheetFooter>}
      </SheetContent>
    </Sheet>
  );
}
